import React from 'react';
import ReactDOM from 'react-dom';

const render = (Component) => (props) => {
  ReactDOM.render(
    <Component
      {...props}
    />,
    document.querySelector('#root,#domain-search-app'),
  );
};

export default render;
